import { convertNodeToElement } from 'react-html-parser';
import { DEV_URL } from './constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformSource(node: any, index: number): JSX.Element {
	if (node.type === 'tag' && node.name === 'img') {
		const { src } = node.attribs;
		// eslint-disable-next-line no-param-reassign
		node.attribs.src =
			process.env.NODE_ENV === 'production' ? src : DEV_URL + src;
		return convertNodeToElement(node, index, transformSource);
	}

	return convertNodeToElement(node, index, transformSource);
}

export function transformArrToListMarkup(array: []): string {
	let convertedString = '<ul class="uikit-inline-list">';
	array.forEach((item) => {
		convertedString += `<li>${item}</li>`;
	});
	convertedString += '</ul>';
	return convertedString;
}

export function constructCropperImage(
	src: string,
	point: { left: string | null; top: string },
	coordinates: null | { x1: string; y1: string; x2: string; y2: string },
	width: number,
	height: number
): string {
	let newSrc: string = src;
	if (!coordinates) {
		newSrc += `?center=${point?.top},${point?.left}&mode=crop`;
	} else {
		newSrc += `?crop=${coordinates.x1},${coordinates.y1},${coordinates.x2},${coordinates.y2}&cropmode=percentage`;
	}
	newSrc += `&width=${width}&height=${height}`;
	return newSrc;
}

export function constructDevSrc(src: string): string {
	if (process.env.NODE_ENV !== 'production') {
		return DEV_URL + src;
	}
	return src;
}

export function formatBytes(bytes: number) {
	const marker = 1024; // Change to 1000 if required
	const decimal = 0; // Change as required
	const kiloBytes = marker; // One Kilobyte is 1024 bytes
	const megaBytes = marker * marker; // One MB is 1024 KB
	const gigaBytes = marker * marker * marker; // One GB is 1024 MB

	// return bytes if less than a KB
	if (bytes < kiloBytes) return `${bytes} Bytes`;
	// return KB if less than a MB
	if (bytes < megaBytes) return `${(bytes / kiloBytes).toFixed(decimal)}KB`;
	// return MB if less than a GB
	if (bytes < gigaBytes) return `${(bytes / megaBytes).toFixed(decimal)}MB`;
	// return GB if less than a TB
	return `(bytes / gigaBytes).toFixed(decimal)GB`;
}

export function separateCityCountry(address: string) {
	const addressArr = address.split(',');
	return {
		city: addressArr[0],
		country: addressArr[addressArr.length - 1].trim(),
	};
}
